// JS file for Contact
import u from '@main';

// u.$ui.bootstrap.tooltip();

const form = '#contact-form';

u.formValidation()
  .then(() => u.$ui.disableOnSubmit(form));
u.form(form).initComponent();
u.$ui.keepAlive(location.href);

const messages = u.data('message');

if(messages) {
  const modal = new bootstrap.Modal(document.getElementById('contactModal'), {
    keyboard: false
  })
  modal.show();
}
